import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const BCTP = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div>
			<Navbar />
			<div
				style={{
					backgroundImage:
						"url('https://aryaaviation.com/assets/images/6.jpg')",
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					BUS AND CAR BOOKING SYSTEM
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					BUS AND CAR BOOKING SYSTEM
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					Bus and Car Booking Website development
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/28.png' />
						</Grid>
						<Grid item xs={8}>
							<p>
								Arya Aviation provides a platform for Bus and Car Booking
								System, in which a customer feels free to book the same
								services. Our Bus & Car Booking System is linked with the APIs
								which helps in finding the best routes for the customers easily.
								These services show the particular city as per search by the
								user. After selecting the particular segment customer can easily
								filter the fares and redirect directly to the payment gateway
								for payment. A customer can generate the Invoice for Bus & Car
								services.
							</p>
							<br />
							<p>
								While booking trips, Car Booking System can save the time that
								goes into selecting rental cars from the various options. Car
								API is integrated to get wide choices of rental cars from
								multiple suppliers across India at different and reasonable
								prices. Car Booking System offers advance booking of rental
								cars. Our Car booking API provides different types of cars in
								each city of India. Your customers can choose car as per their
								convenience. Through a single API Integration you get select and
								book rental car from multiple options available. Car Booking
								System helps to manage bookings by generation Booking and
								Cancellation Reports.
							</p>
							<br />
							<p>
								Bus Booking System provides all the real time availability of
								buses for selected segment. Your Customers just search the
								segment and all the available buses for this route will be
								displayed. To show the real time availability, Bus API is
								integrated which shows data from multiple suppliers across PAN
								India providing wide choices to the Customers. Bus Booking
								System provides Search, Select Seat and Confirm - through a
								single API Integration. You can easily generate the Booking and
								Cancellation reports.
							</p>
							<br />
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>

			<Footer />
		</div>
	);
};

export default BCTP;
